var map = {
	"./": 54,
	"./compareTranslations": 114,
	"./compareTranslations.js": 114,
	"./de": 69,
	"./de.js": 69,
	"./en": 67,
	"./en.js": 67,
	"./es": 70,
	"./es.js": 70,
	"./fr": 68,
	"./fr.js": 68,
	"./hosarim/data.csv": 208,
	"./hosarim/de_hosarim.csv": 209,
	"./hosarim/es_hosarim.csv": 210,
	"./hosarim/fr_hosarim.csv": 211,
	"./index": 54,
	"./index.js": 54,
	"./it": 71,
	"./it.js": 71,
	"./updateDictionary": 116,
	"./updateDictionary.js": 116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;